import { DeliveryRegistrationFormUi } from '@/components/Order/OrderDetails/DeliveryRegistrationForm/DeliveryRegistrationFormUi';
import { OrderDeliveryInfoRequest } from '@/data/api/model/orders/detailOrdersDeliveryInfoDto';

export function deliveryRegistrationFormUiToOrderDeliveryInfoRequest(
  input: DeliveryRegistrationFormUi
): OrderDeliveryInfoRequest {
  return {
    final_total_order_detail_amount: parseFloat(input.deliveryTotalAmount),
    final_delivery_date: input.deliveryConfirmedDate
      ? input.deliveryConfirmedDate.format('YYYY-MM-DD')
      : '',
    final_delivery_time: input.deliveryConfirmedTime
      ? input.deliveryConfirmedTime.format('HH:mm')
      : '',
    final_delivery_notes: input.deliveryConfirmedNotes || '',
    warranty_applied: input.appliedMercantoWarranty,
    adjusted_product_prices: input.deliveryProductPriceAdjusted,
    all_products_completed: input.deliveryOrderCompleted,
    includes_extra_products: input.deliveryOrderExtraProducts,
  };
}
